import type { JobView } from '@api/devices/contracts';
export function InstallCompatibilityFacts({ job }: { job: JobView }) {
  const check = job.installCompatibility;
  if (!check) return null;
  const p = check.requirements;
  return <section aria-label="Package compatibility" className="space-y-2 rounded-xl border border-line p-3 text-[13px]">
    <p className="font-semibold">{p.packageId} {p.packageVersion}</p>
    <p>{check.result?.reason ?? 'Live compatibility check pending; inventory alone does not qualify installation.'}</p>
    <p>Windows {p.windows.map(r => `${r.version} build ${r.minBuild}–${r.maxBuild}`).join(', ')} · {p.architectures.join(', ')} · {(p.minFreeBytes / 1e9).toFixed(1)} GB free needed on package volumes.</p>
    <p>{p.requireClearReboot ? 'A pending restart holds this package.' : 'This package permits a pending restart.'}
      {(p.conflicts.products.length + p.conflicts.services.length) > 0 && ' Declared conflicting products and services are checked before download.'}</p>
    <p className="text-ink-3">Installation verification remains separate from compatibility checks.</p>
  </section>;
}
